import { Checkbox } from 'antd';
import clx from 'classnames';
import { CheckboxGroupProps } from 'antd/lib/checkbox';

import './style.scss';

export const AppCheckboxGroup = ({ className, onChange, ...rest }: CheckboxGroupProps) => (
  <Checkbox.Group {...rest} onChange={onChange} className={clx('pl-checkbox', className)} />
);
